import React, {useState} from 'react';
import Grid from '@mui/material/Grid2';
import {useTranslation} from "react-i18next";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import GetConfirmationButton from "../../../../components/elements/GetConfirmationButton";
import {Card, Switch, Typography, useMediaQuery} from "@mui/material";
import {CheckBoxRounded} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {currencySymbol, getMediaURL, price, truncate} from "../../../../../config/values";
import Box from '@mui/material/Box';
import {BriefcaseBusiness, Trash} from "lucide-react";
import {Link} from "react-router-dom";
import DonateButton from "../../../manage/charities/components/DonateButton";
import PurchaseForCharityButton from "../../../manage/charities/components/PurchaseForCharityButton";
import {theme} from "../../../../../config/design/theme";

function CharityCardFront({classes,item,reload}){
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Card className="item-card bg-card charity-card">
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Box>
                        <div className="flex-justify-center d-flex align-center flex-column">
                            <img className="charity-logo" src={getMediaURL(item.file,'small')} alt={item.name}/>
                            <Typography align="center" className="bold" style={{marginTop:7,marginBottom:8}}>
                                {item.name}
                            </Typography>
                            <div className="flex-direction mb-5">
                                <BriefcaseBusiness className="lucide-small-narrow"/>
                                <span style={{fontSize:13}}>{truncate(item.activity_field,!!isMobile ? 10 : 20)}</span>
                            </div>
                        </div>
                    </Box>

                    {
                        !isMobile &&
                        <div className="mb-10 flex-direction" style={{textAlign:"left", padding:5}}>
                            <span className="charity-desc">{truncate(item.description,75)}</span>
                        </div>
                    }
                    <div className="text-center flex-direction flex-justify-center flex-column-md justify-md-center align-center align-md-center" >
                        <DonateButton item={item}/>
                        <PurchaseForCharityButton item={item}/>
                    </div>

                </Grid>
            </Grid>
        </Card>
    );
}
export default withStyles(Styles)(CharityCardFront);
